<template>
  <div id="passwd_hint_content" class="password-validation" v-show="isValid == 'fail'">
    <ul>
      <li>
        <span>{{ $t("passwd_condition_weak") }}</span>
      </li>
      <li>
        <ul>
          <li>
            <div class="pwd-checkbox" :class="{ checked: check.len }"></div>
            <span>{{ $t("password_reset_conditions5_1_weak") }}</span>
          </li>
          <li>
            <div class="pwd-checkbox" :class="{ checked: check.uppercase }"></div>
            <span>{{ $t("password_reset_conditions1_contains") }}</span>
          </li>
          <li>
            <div class="pwd-checkbox" :class="{ checked: check.lowercase }"></div>
            <span>{{ $t("password_reset_conditions2_contains") }}</span>
          </li>
          <li v-if="$store.state.user.board_region == 'AP'">
            <div class="pwd-checkbox" :class="{ checked: check.diff_char }"></div>
            <span>{{ $t("password_reset_conditions6") }}</span>
          </li>
         </ul>
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  props: {
    password: {
      type: String,
      default: "",
    },
    valid: {
      type: String,
      default: "init",
    },
  },
  data() {
    return {
      check: {
        len: false,
        diff_char: false,
        uppercase: false,
        lowercase: false,
        number: false,
        special: false,
      },
      init: true,
    };
  },
  computed: {
    reachThereCondition() {
      let count = 0;

      if (this.check.uppercase) count++;
      if (this.check.lowercase) count++;
//      if (this.check.number) count++;
//      if (this.check.special) count++;

      return count >= 2;
    },
    isValid() {
      if (this.init || this.password == "") {
        return "init";
      }
      if (this.$store.state.user.board_region == 'AP') {
        if (this.check.len && this.check.diff_char && this.reachThereCondition) {
          return "pass";
        } else {
          return "fail";
        }
      }
      else {
        if (this.check.len && this.reachThereCondition) {
          return "pass";
        } else {
          return "fail";
        }
      }
    },
  },
  watch: {
    password: {
      handler(newValue) {
        const pwd = newValue;
        if (typeof pwd === "undefined") return;
        if (pwd != "" && this.init) {
          this.init = false;
        }

        this.check.len = pwd.length >= 10 && pwd.length <= 32;
        this.check.diff_char = pwd != "" && !new RegExp("^.*(.)\\1{2}.*$").test(pwd);
        this.check.uppercase = pwd != "" && new RegExp("[A-Z]").test(pwd);
        this.check.lowercase = pwd != "" && new RegExp("[a-z]").test(pwd);
//        this.check.number = pwd != "" && new RegExp("[0-9]").test(pwd);
//        this.check.special = pwd != "" && new RegExp("((?=[\x21-\x7e]+)[^A-Za-z0-9])").test(pwd);
        this.$emit("update:valid", this.isValid);
      },
      immediate: true,
    },
  },
};
</script>
<style lang="scss">
.password-validation {
  margin-top: 10px;
  background: #f0eceb;
  border-radius: 20px;
  display: inline-block;
  ul {
    margin: 10px 22px;
    padding-left: 0;
    width: 430px;
    li {
      list-style-type: none;
      text-align: left;
    }
  }
  .pwd-checkbox {
    width: 20px;
    height: 20px;
    background: url("~images/checkbox-selected-gry.svg");
    display: inline-block;
    margin-right: 5px;
  }
  .pwd-checkbox.checked {
    background: url("~images/checkbox-selected.svg");
  }
}
</style>
